

.container
{
  display: flex;
  justify-content: center;
  align-items: center;

  .center {
    background-color: white;
    border-radius: var(--border-radius);
    padding: 1.25em;

    p {
      //text-align: center;
    }
    .icons {
      display: flex;
      gap: 1.25em;

      .iconAccept {
        cursor: pointer;
        background-color: var(--green);
      }

      .iconDeny {
        cursor: pointer;
        background-color: var(--red);
      }
    }
  }
}